import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router';
import { api } from '../models/api-client.js';
import { queryKeys } from '../models/query-keys.js';
import { useSession } from './session-context.jsx';

export function useProperties() {
  const { user, setUser, setFilters } = useSession();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const sites = useQuery({
    queryKey: queryKeys.sites(user.google_id),
    queryFn: ({ signal }) => api('/api/webmasters/sites', { signal }),
  });
  const selection = useMutation({
    mutationFn: siteUrl => api('/api/webmasters/select-site', { body: { siteUrl } }),
    onSuccess: data => {
      queryClient.removeQueries({ queryKey: queryKeys.allAnalytics });
      setUser(data.user);
      setFilters(previous => ({ ...previous, country: 'all', device: 'all' }));
      navigate('/dashboard');
    },
  });
  return { sites, selection };
}
